import { render, staticRenderFns } from "./MerchantLogs.vue?vue&type=template&id=206bf9ba"
import script from "./MerchantLogs.vue?vue&type=script&lang=js"
export * from "./MerchantLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports